import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Card' {
  interface CardOwnProps {
    contentPadding?: 'sm' | 'md' | 'lg' | 'none';
  }
}

export const getSurfaceComponents = (
  theme: Theme,
): Pick<
  Components,
  'MuiCard' | 'MuiAccordionSummary' | 'MuiPaper' | 'MuiDivider'
> => ({
  MuiCard: {
    defaultProps: {
      elevation: 0,
      contentPadding: 'sm',
    },

    styleOverrides: {
      root: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        boxShadow: 'none',
        overflow: 'unset',
      },
    },

    variants: [
      {
        props: { contentPadding: 'none' },
        style: {
          padding: 0,
        },
      },
      {
        props: { contentPadding: 'sm' },
        style: {
          padding: theme.lelySpacing.SM,
        },
      },
      {
        props: { contentPadding: 'md' },
        style: {
          padding: theme.lelySpacing.MD,
        },
      },
      {
        props: { contentPadding: 'lg' },
        style: {
          padding: theme.lelySpacing.LG,
        },
      },
    ],
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: 'none',
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        '& .MuiSvgIcon-root': {
          color: theme.palette.text.subtle,
        },
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(255, 255, 255, 0.32)',
        borderRadius: theme.lelyBorderRadius.SM,
      },
    },
  },
});
